import type { Prototype } from "../prototype-types";

export const alexTsarapkinePrototypes: Prototype[] = [
  {
    id: "ats-pdp-message-button-top-nav",
    name: "PDP Message Button in Top Nav",
    path: "/ats/pdp-message-button-top-nav",
    description:
      "Moves Message brand out of the More from brand header, either next to the cart at the top of the PDP (circle or labeled pill) or in place of share next to the favorite icon.",
    owner: "Alex Tsarapkine",
    createdAt: "2026-10-20",
    lastUpdated: "2026-10-22",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "cursor",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/5f05e60c6912062edabc51bbbaba9b0d35e98193c20295a48b165521e9f69b63.png",
  },
  {
    id: "ats-apparel-preorder-nav",
    name: "Apparel Preorder Nav",
    path: "/ats/apparel-preorder-nav",
    description:
      "Three ways to add an All preorders view for apparel brands on the brand page, each with the category nav XP off and on, on desktop and mobile web.",
    owner: "Alex Tsarapkine",
    createdAt: "2026-10-27",
    lastUpdated: "2026-10-27",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "claude-code",
    thumbnail: "/images/thumbnails/ats-apparel-preorder-nav.png",
  },
];
